// 数据为空或区块被停用时，不能给顾客显示没有目的地的页内导航。
function productTabTargets(tab) {
  if (!tab) return $();
  const selector = tab.getAttribute('data-type');
  if (!selector) return $();
  try {
    return $(selector).filter(function () { return this.getClientRects().length && getComputedStyle(this).visibility !== 'hidden'; });
  } catch (_) { return $(); }
}

function refreshProductTabs() {
  $('.custom-tabs-contentBox .new_sed_menu').each(function () {
    this.hidden = !this.querySelector('a[href]') && !productTabTargets(this).length;
  });
}
refreshProductTabs();
document.addEventListener('shopify:section:load', refreshProductTabs);
window.addEventListener('resize', debounce(refreshProductTabs));
function scrollProductTabTarget(targets) {
  const headers = ['.section-countdown-timer-bar', 'header.header', '.main-product-tab'];
  const height = headers.reduce((sum, selector) => sum + ($(selector).outerHeight() || 0), 0);
  // html 的 offset 会跟着当前滚动位置变化；页内导航必须使用目标的绝对位置。
  const top = Math.max(0, Math.floor(targets.first().offset().top - height));
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  $('html,body').stop(true);
  window.scrollTo({ top, behavior: reduced ? 'instant' : 'smooth' });
}
$(document).on('click', '.custom-tabs-contentBox .new_sed_menu:not([hidden])', function (event) {
  if (this.querySelector('a[href]')) return;
  event.preventDefault();
  const targets = productTabTargets(this);
  if (targets.length) scrollProductTabTarget(targets);
});
$(document).on('keydown', '.custom-tabs-contentBox .new_sed_menu[role="button"]', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  event.preventDefault();
  this.click();
});

$(window).scroll(debounce(function () {
  var scrollTop = window.scrollY || document.documentElement.scrollTop;
  var topHeight = parseInt(windowScrollHeight()) + parseInt($('.custom-tabs-content').outerHeight());

  $('.custom-tabs-contentBox .new_sed_menu:not([hidden])').each(function () {
    const targets = productTabTargets(this);
    if (targets.length > 0) {
      const eleTop = Math.floor(targets.offset().top);
      const windowScroll = scrollTop + topHeight;
      if (windowScroll + 10 >= eleTop) {
        $('.custom-tabs-contentBox .new_sed_menu').removeClass('active');
        $(this).addClass('active');
      }
    }
  })
}))
